export const OFFER = {
  ref: "VOFE-ODOO-2026-007",
  date: "21 September 2026",
  validUntil: "20 October 2026",
  validUntilISO: "2026-10-20T23:59:59+04:00",
  consultant: "Mohamed Abo Sleem",
  consultantRole: "Senior Odoo Consultant",
  client: "Vision Oil Field Equipment LLC",
  contacts: [
    { name: "Mr. Ahmed Hamouda", role: "Chief Executive Officer" },
    { name: "Mr. Ahmed Maged", role: "Admin. Director" },
  ],
  project: "Odoo ERP Implementation Services Project",
  footprint: ["UAE (HQ · Abu Dhabi)", "Saudi Arabia", "Qatar", "Egypt"],
  currency: "AED",
};

export const OPTION = {
  id: "consultancy",
  name: "Consultancy Engagement",
  tag: "Direct consultant contract · No company contract",
  base: 130000,
  originalBase: 150000,
  vat: 0,
  total: 130000,
  vatNote: "No VAT — invoiced directly by the consultant",
  support: 26000,
  bullets: [
    "Signed directly with Mohamed Abo Sleem as independent Senior Odoo Consultant",
    "No VAT applied on professional fees",
    "Identical scope, phases, team and delivery governance",
    "Fastest, most cost-efficient path to kickoff",
    "Odoo Enterprise license & hosting are not included — paid directly to Odoo",
  ],
};

export const ANNUAL_COSTS = [
  {
    name: "Hosting on odoo.sh",
    aed: 6166,
    usd: "1,680",
    note: "Per year — managed cloud hosting on Odoo.sh, paid directly to Odoo",
  },
  {
    name: "Odoo Enterprise License",
    aed: 22020,
    usd: "6,000",
    note: "Per year · USD 25 / user / month · assumes 20% discount — subject to negotiation & approval with Odoo · paid directly to Odoo",
  },
];

export const MILESTONE_PCTS = [25, 15, 15, 15, 15, 15];
export const MILESTONE_NAMES = [
  "Sign-off & Project Kickoff",
  "Phase 01 — Operational Core Complete",
  "Phase 02 — Rental & Service Complete",
  "Phase 03 — Manufacturing Complete",
  "Phase 04 — Finance & Compliance Complete",
  "Go-Live & Final Handover",
];
export const MILESTONE_DUES = [
  "Upon agreement execution",
  "Upon UAT sign-off of Phase 01",
  "Upon UAT sign-off of Phase 02",
  "Upon UAT sign-off of Phase 03",
  "Upon UAT sign-off of Phase 04",
  "System go-live",
];

export const CHALLENGES = [
  { area: "Finance", title: "Multi-country operations & consolidation", solution: "Multi-Company + Consolidation" },
  { area: "Compliance", title: "Tax & e-invoicing — UAE · KSA · Egypt", solution: "Accounting + Country Localizations" },
  { area: "Operations", title: "Equipment rental lifecycle & utilization", solution: "Rental + Inventory + Fleet" },
  { area: "Production", title: "Manufacturing, BOMs & quality control", solution: "MRP + PLM + Quality" },
  { area: "Service", title: "Field service & preventive maintenance", solution: "Field Service + Maintenance" },
  { area: "Inventory", title: "Spare parts & multi-warehouse visibility", solution: "Inventory + Barcode" },
  { area: "Procurement", title: "Requisition & purchase approval processing", solution: "Purchase + Approvals + Sign" },
  { area: "Insight", title: "Visibility & decision-making", solution: "Dashboards + BI" },
  { area: "Integration", title: "Fragmented processes & Excel sprawl", solution: "Documents + Approvals + CRM" },
  { area: "HR", title: "HR records, payroll & WPS compliance", solution: "Employees + Payroll + Time Off + Appraisals" },
];

export const MODULES = [
  { name: "CRM & Tender Pipeline", icon: "Target", desc: "Capture tenders from portals and email, structured pipeline and forecast across four countries." },
  { name: "Sales & Quotations", icon: "TrendingUp", desc: "Technical quotations, multi-tier discount workflows, customer portal and pipeline analytics." },
  { name: "Rental Lifecycle", icon: "CalendarClock", desc: "Availability by serial number, rental contracts, damage & overdue recharges via Studio — zero double bookings." },
  { name: "Inventory & Barcode", icon: "Package", desc: "Multi-warehouse across 4 countries, lots & serials, consignment stock, reordering rules and cycle counts." },
  { name: "Procurement & Approvals", icon: "ShoppingCart", desc: "Requisition → RFQ → PO → goods receipt, approval matrix with delegation, three-way match before payment." },
  { name: "Manufacturing (MRP)", icon: "Factory", desc: "Multi-level BOMs & routings for the 11 equipment lines, work orders and shop-floor sequencing." },
  { name: "PLM & Quality", icon: "ClipboardCheck", desc: "Engineering change orders, CAD attachments, FAT / DNV / API inspection points bound to serialized units." },
  { name: "Field Service", icon: "Wrench", desc: "Technician planning & dispatch, mobile checklists, photos and on-site customer signature capture." },
  { name: "Maintenance", icon: "Cog", desc: "Preventive schedules with hour-meter triggers, downtime history per asset feeding reliability decisions." },
  { name: "Asset Management", icon: "Boxes", desc: "Complete asset register for serialized equipment — depreciation, lifecycle cost, utilization and margin per unit across all branches." },
  { name: "Project & Timesheets", icon: "Timer", desc: "True job costing — labor, parts and travel consolidated per job, per unit and per client." },
  { name: "Employees & UAE Payroll", icon: "Users", desc: "Employee records & contracts, WPS payroll generation, end-of-service gratuity and UAE labor-law compliance." },
  { name: "Time Off, Attendance & Appraisals", icon: "CalendarCheck", desc: "Leave management, attendance & shift tracking, recruitment pipeline, onboarding and performance appraisals." },
  { name: "Accounting & E-Invoicing", icon: "Calculator", desc: "Multi-company consolidation in AED, UAE FTA-ready, KSA ZATCA, Egypt ETA, VAT & Corporate Tax returns." },
  { name: "Documents, Sign & BI", icon: "PieChart", desc: "OCR document repository, e-signature, real-time dashboards by branch, unit and project, Studio extensions." },
];

export const PHASES = [
  { phase: "Phase 00", title: "Discovery & Blueprint", duration: "2 – 3 weeks", deliverable: "Process workshops across the four countries. Output: signed blueprint and detailed scope of work per phase." },
  { phase: "Phase 01", title: "Operational Core", duration: "6 – 8 weeks", deliverable: "Multi-company & multi-warehouse structure, items/lots/serials, requisition-to-PO approval matrix, Sales & CRM, plus the full HR suite — employees, UAE WPS payroll, time off, attendance & appraisals." },
  { phase: "Phase 02", title: "Rental & Service", duration: "6 – 8 weeks", deliverable: "Rental availability calendar, contract templates with Studio extensions, Field Service, Maintenance, Timesheets." },
  { phase: "Phase 03", title: "Manufacturing", duration: "6 – 8 weeks", deliverable: "MRP multi-level BOMs & routings for the 11 lines, PLM change control, Quality gates for FAT / API / DNV." },
  { phase: "Phase 04", title: "Finance & Compliance", duration: "6 – 8 weeks", deliverable: "Per-entity books, consolidation, e-invoicing (UAE FTA, KSA ZATCA, Egypt ETA), VAT/CT returns, bank feeds." },
  { phase: "Phase 05", title: "Go-Live & Hypercare", duration: "4 – 6 weeks", deliverable: "Data migration, UAT, role-based training across four branches, Go-Live on a fiscal boundary, 4-week hypercare." },
];

export const TEAM = [
  { role: "Odoo Project Manager", scope: "Owns the plan, scope control and risk register. Runs the weekly steering committee and phase stage-gates. Single point of contact on the delivery side." },
  { role: "Techno-Functional Consultant — Operations", scope: "Inventory & multi-warehouse, purchase & approval matrix, rental lifecycle, field service, maintenance, asset management, project & timesheets, HR & UAE WPS payroll." },
  { role: "Techno-Functional Consultant — Manufacturing & Finance", scope: "MRP, PLM & Quality, accounting, multi-company consolidation, country localizations and e-invoicing, data migration." },
];

export const CLIENT_TEAM = [
  "Project Sponsor (CEO / CFO designate)",
  "Single Point of Contact",
  "Finance key users — one per country",
  "Operations / Rental lead",
  "Procurement / Stores lead",
  "Manufacturing engineer",
  "Service / Maintenance coordinator",
];

export const GOVERNANCE = [
  "Weekly steering committee",
  "Stage-gate sign-off at every phase end",
  "Vision-owned tenant from day one",
  "Fixed scope per phase — changes via change request",
];

export const ASSUMPTIONS = [
  { id: "A1", text: "Client key users are available for workshops, UAT and training across all four countries as scheduled." },
  { id: "A2", text: "Client owns data cleansing and master-data validation (customers, suppliers, items, BOMs)." },
  { id: "A3", text: "Project scope is the 4 entities, 11 equipment lines and 7 service lines as defined in the proposal." },
  { id: "A4", text: "Client decision-makers are available within agreed SLAs at each stage-gate." },
];

export const EXCLUSIONS = [
  { id: "E1", text: "Third-party integrations (bank portals, customs, non-Odoo invoicing gateways) handled separately." },
  { id: "E2", text: "Local e-invoicing certification add-ons outside the Odoo platform — via the partner network." },
  { id: "E3", text: "Hardware, network and devices at client sites — client infrastructure scope." },
  { id: "E4", text: "Onsite travel days and dedicated hosting arrangements — agreed separately." },
];

export const TERMS = [
  { title: "Payment Terms", desc: "Invoices are payable within 14 days of issue via bank transfer. All amounts in UAE Dirhams." },
  { title: "Annual Recurring Costs", desc: "Odoo.sh hosting and Enterprise licenses are not included in the implementation fee — they are billed annually and paid directly to Odoo. Annual support is 20% of the contract value, billed from Go-Live." },
  { title: "Confidentiality", desc: "All commercial and technical information exchanged during the engagement is governed by mutual NDA obligations." },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1516199423456-1f1e91b06f25?q=80&w=1920&auto=format&fit=crop",
  rig: "https://images.unsplash.com/photo-1633155617309-6201a8096e8a?q=80&w=1600&auto=format&fit=crop",
  pumps: "https://images.unsplash.com/photo-1690508313456-bf8c851e8319?q=80&w=1200&auto=format&fit=crop",
};

export const fmt = (n) => new Intl.NumberFormat("en-AE").format(n);
